import { useT } from '_metronic/i18n/Metronici18n'
import { situacaoNotaLabels } from '../../../../../../../_metronic/helpers'
import { PageHeading, StatCardItem, StatCards, StatusDot } from '../../../../../../components'
import { situacaoNotaTone } from '../../../notas-list/table/columns/_columns'
import { useQueryResponse } from '../../core/QueryResponseProvider'

/**
 * Resumo da nota acima da listagem: profissional como título; período e observação como apoio;
 * situação, valor e as datas do fluxo (fechamento → recebimento → pagamento) em cards.
 */
export const NotaAtendimentosListInfo = () => {
  const { responseSemPaginacao: nota } = useQueryResponse()
  const { t } = useT()
  const situacao = nota?.situacao

  const stats: StatCardItem[] = [
    {
      label: t('situacao.label'),
      value: (
        <StatusDot
          label={situacao ? situacaoNotaLabels[situacao] : undefined}
          tone={situacao ? situacaoNotaTone[situacao] : undefined}
        />
      ),
    },
    { label: t('valor.label'), value: nota?.valorFormatado },
    { label: t('fechamento.label'), value: nota?.dataFechamentoFormatada },
    { label: t('recebimento.label'), value: nota?.dataRecebimentoFormatada },
    { label: t('pagamento.label'), value: nota?.dataPagamentoFormatada },
  ]

  return (
    <>
      <PageHeading
        title={nota ? nota.profissional?.nome || t('nota.label') : 'Carregando nota…'}
        description={
          [
            nota?.mesAno?.descricao && `${t('periodo.label')}: ${nota.mesAno.descricao}`,
            nota?.observacao && `${t('observacao.label')}: ${nota.observacao}`,
          ]
            .filter(Boolean)
            .join(' — ') || undefined
        }
      />
      <StatCards items={stats} ariaLabel='Resumo da nota' />
    </>
  )
}
